import Vue from 'vue'
import MapBoxDataFactory from './MapBoxDataFactory';
import {
    EventBus
} from './DataManagement/EventBus';

export default class LayerManager {
    constructor() {
        this._vue = new Vue();
        this.layers = [];
        this.sources = [];
        this.layerOpacities = {
            A: 0,
            B: 1
        }
        this.sidesToUpdate = [];
        this.vapStyleSet = false;
    }

    layerExists(layerId) {
        return this._vue.$map.getLayer(layerId) !== undefined;
    }

    addLayersToMap(map) {
        this._vue.$pgConfig.forEach((proposal) => {
            const source = new MapBoxDataFactory('source', proposal);
            const layerA = new MapBoxDataFactory('layer', proposal, 'A');
            const layerB = new MapBoxDataFactory('layer', proposal, 'B');

            map.addSource(source.name, source.data);
            map.addLayer(layerA, 'proposal-outline-placeholder');
            map.addLayer(layerB, 'proposal-outline-placeholder');
            this.layers.push(layerA);
            this.layers.push(layerB);
            this.sources.push(source);

            //Labels
            const labelSource = new MapBoxDataFactory('label-source', proposal);
            const layerAlabel = new MapBoxDataFactory('label-layer', proposal, 'A');
            const layerBlabel = new MapBoxDataFactory('label-layer', proposal, 'B');

            map.addSource(labelSource.name, labelSource.data);
            map.addLayer(layerAlabel, 'proposal-label-placeholder');
            map.addLayer(layerBlabel, 'proposal-label-placeholder');
        });


        // const voteLayerProps = {
        //     tablename: this._vue.$voteLayerConfig.config["postgres-tablename"]
        // }


        // const voteSource = new MapBoxDataFactory('voting-source', voteLayerProps);
        // const voteLayer = new MapBoxDataFactory('voting-layer', voteLayerProps);

        // map.addSource(voteSource.name, voteSource.data);
        // map.addLayer(voteLayer, 'vote-layer-placeholder');

        const vapLayerProps = {
            tablename: this._vue.$VAPConfig.config["postgres-tablename"]
        }

        const vapSource = new MapBoxDataFactory('vap-source', vapLayerProps);
        const vapLayer = new MapBoxDataFactory('vap-layer', vapLayerProps);

        map.addSource(vapSource.name, vapSource.data);
        map.addLayer(vapLayer, 'vote-layer-placeholder');

        if (this._vue.$coiConfig) {
            const coiLayerProps = {
                tablename: this._vue.$coiConfig.config["postgres-tablename"],
                style: this._vue.$coiConfig.config["style"]
            }

            const coiSource = new MapBoxDataFactory('coi-source', coiLayerProps);
            const coiLayer = new MapBoxDataFactory('coi-layer', coiLayerProps);

            map.addSource(coiSource.name, coiSource.data);
            map.addLayer(coiLayer, 'vote-layer-placeholder');

            const coiLabelSource = new MapBoxDataFactory('coi-label-source', {
                tablename: this._vue.$coiConfig.config["postgres-tablename"]
            });
            const coiLabelLayer = new MapBoxDataFactory('coi-label-layer', {
                tablename: this._vue.$coiConfig.config["postgres-tablename"]
            });

            map.addSource(coiLabelSource.name, coiLabelSource.data);
            map.addLayer(coiLabelLayer, 'proposal-label-placeholder');
        }

        const aerialSource = new MapBoxDataFactory('aerial-source');
        const aerialLayer = new MapBoxDataFactory('aerial-layer');

        map.addSource(aerialSource.name, aerialSource.data);
        map.addLayer(aerialLayer, 'aerial-layer-placeholder');
    }

    showProposal(sideOptions) {
        let layerId = sideOptions._id;
        const side = sideOptions._side;

        // Get default layer if there is none
        if (!layerId || layerId.length === 0) layerId = this.getDefaultLayerForSide(side).tablename;

        //This is way more complicated than it should be because if the opacity isn't managed like this it will flash before being made visible

        // if the layer doesn't exist yet, bail out
        if (!this.layerExists(`${layerId}-${side}`)) {
            console.warn(`Layer '${layerId}-${side}' does not exist in the map's style.`);
            return;
        }

        const paintProperties = this._vue.$styleConfig.styles.outlines.paint[`Prop-${side}`];
        Object.keys(paintProperties).forEach((prop) => {
            if (this.layerExists(`${layerId}-${side}`)) {
                this._vue.$map.setPaintProperty(`${layerId}-${side}`, prop, paintProperties[prop]);
            }
        });

        if (this.layerExists(`${layerId}-label-${side}`)) {
            this._vue.$map.setPaintProperty(`${layerId}-label-${side}`, "text-opacity", 0);
        }
        if (this.layerExists(`${layerId}-${side}`)) {
            this._vue.$map.setPaintProperty(`${layerId}-${side}`, "line-opacity", 0);
        }

        this._vue.$map.once('styledata', () => {
            this._vue.$pgConfig.forEach((l) => {
                if (!layerId.includes(l.tablename) && l
                    .tags
                    .replace(' ', '')
                    .split(',')
                    .includes('jurisdiction')) {

                    if (this.layerExists(`${l.tablename}-label-${side}`)) {
                        this._vue.$map.setPaintProperty(`${l.tablename}-label-${side}`, "text-opacity", 0);
                        this._vue.$map.setLayoutProperty(`${l.tablename}-label-${side}`, 'visibility', 'none');
                    }
                    if (this.layerExists(`${l.tablename}-${side}`)) {
                        this._vue.$map.setPaintProperty(`${l.tablename}-${side}`, "line-opacity", 0);
                        this._vue.$map.setLayoutProperty(`${l.tablename}-${side}`, 'visibility', 'none');
                    }
                }
            });

            if (this.layerExists(`${layerId}-${side}`)) {
                this._vue.$map.setLayoutProperty(`${layerId}-${side}`, 'visibility', 'visible');
            }
            if (this.layerExists(`${layerId}-label-${side}`)) {
                this._vue.$map.setLayoutProperty(`${layerId}-label-${side}`, 'visibility', 'visible');
            }

            if (this.layerExists(`${layerId}-label-${side}`)) {
                this._vue.$map.setPaintProperty(`${layerId}-label-${side}`, "text-opacity", this.layerOpacities[side]);
            }
            if (this.layerExists(`${layerId}-${side}`)) {
                this._vue.$map.setPaintProperty(`${layerId}-${side}`, "line-opacity", this.layerOpacities[side]);
            }

            const propColor = this.getColorForProposal(layerId);

            // Guarded color assignments (previously unguarded)
            if (this.layerExists(`${layerId}-label-${side}`)) {
                this._vue.$map.setPaintProperty(`${layerId}-label-${side}`, "text-color", propColor);
            }
            if (this.layerExists(`${layerId}-${side}`)) {
                this._vue.$map.setPaintProperty(`${layerId}-${side}`, "line-color", propColor);
            }
        });
    }

    hideProposal(layerId, side) {
        if (this.layerExists(`${layerId}-${side}`)) {
            this._vue.$map.setLayoutProperty(`${layerId}-${side}`, 'visibility', 'none');
        }
        if (this.layerExists(`${layerId}-label-${side}`)) {
            this._vue.$map.setLayoutProperty(`${layerId}-label-${side}`, 'visibility', 'none');
        }
    }

    highlightDistrict(layerId, geoid, side) {
        if (!this.layerExists(`${layerId}-${side}`)) {
            console.warn(`Layer '${layerId}-${side}' does not exist and cannot be highlighted.`);
            return;
        }

        const applyHighlight = () => {
            const defaultLineWidth = this._vue.$styleConfig.styles.outlines.paint[`Prop-${side}`]["line-width"];
            this._vue.$map.setPaintProperty(`${layerId}-${side}`, "line-width", ['match', ['get', 'geoid'], geoid, 5, defaultLineWidth]);
        };

        if (this._vue.$map.isStyleLoaded()) {
            applyHighlight();
        } else {
            this._vue.$map.once("idle", applyHighlight);
        }
    }

    unhighlightDistricts(layerId, side) {
        if (!this.layerExists(`${layerId}-${side}`)) {
            console.warn(`Layer '${layerId}-${side}' does not exist and cannot be unhighlighted.`);
            return;
        }
        const defaultLineWidth = this._vue.$styleConfig.styles.outlines.paint[`Prop-${side}`]["line-width"];
        this._vue.$map.setPaintProperty(`${layerId}-${side}`, "line-width", defaultLineWidth);
    }

    getColorForProposal(propid) {
        const _color = `#${this._vue.$pgConfig.filter(p => propid === p.tablename)[0].mapcolor}`;
        return _color;
    }

    setProposalOpacity(id, level, side) {
        this.layerOpacities[side] = level;
        const labelId = id.replace('-', '-label-');
        if (this.layerExists(id) && this.layerExists(labelId)) {
            this._vue.$map.setPaintProperty(id, 'line-opacity', level);
            this._vue.$map.setPaintProperty(labelId, 'text-opacity', level);
        }
    }

    // styleVAPLayer() {
    //     if (!this.vapStyleSet) {
    //         let _data = this._vue.$dataManager.vapData;

    //         const matchExpression = ['match', ['get', 'GEOID']];
    //         const _conf = this._vue.$VAPConfig.config;

    //         for (const row of _data) {
    //             if (row.p) {
    //                 const color = this._vue.$dataManager.GetColor(row.v_pct, _conf[row.p].scale);
    //                 matchExpression.push(row['geoid'], color);
    //             }
    //         }

    //         matchExpression.push('rgba(0, 0, 0, 0)');

    //         const vapId = this._vue.$mainConfig["toggleable-layers"].filter(l => l.tag === "vap-blocks")[0]["layer-ids"][0];

    //         this._vue.$map.setPaintProperty(vapId, 'fill-color', matchExpression);
    //         const _opacity = this._vue.$VAPConfig.config["layer-opacity"];
    //         this._vue.$map.setPaintProperty(vapId, 'fill-opacity', _opacity);

    //         this.vapStyleSet = true;
    //     }
    // }

    // styleVoteLayer() {
    //     if (!this.voteStyleSet) {
    //         let _data = this._vue.$dataManager.voteData;

    //         const matchExpression = ['match', ['get', 'geoid']];
    //         const _conf = this._vue.$voteLayerConfig.config;

    //         for (const row of _data) {
    //             if (row.bidenpct) {
    //                 const color = this._vue.$dataManager.GetColor(row.bidenpct, _conf.scale);
    //                 matchExpression.push(row['geoid'], color);
    //             }
    //         }

    //         matchExpression.push('rgba(0, 0, 0, 0)');

    //         const voteId = this._vue.$mainConfig["toggleable-layers"].filter(l => l.tag === "vote-results")[0]["layer-ids"][0];

    //         this._vue.$map.setPaintProperty(voteId, 'fill-color', matchExpression);
    //         const _opacity = this._vue.$voteLayerConfig.config["layer-opacity"];
    //         this._vue.$map.setPaintProperty(voteId, 'fill-opacity', _opacity);

    //         this.voteStyleSet = true;
    //     }
    // }

    getLayerIDsArray() {
        return this._vue.$pgConfig.map((l) => l.tablename);
    }

    getLayerDisplayNamesArray() {
        return this._vue.$pgConfig.map((l) => l.displayname);
    }

    getLayerDisplayNamesIDsPair(type = 'cd', getCurrent = false) {
        let self = this;
        return this._vue.$pgConfig.filter((l) => {
            return l
                .tags
                .replace(' ', '')
                .split(',')
                .includes(type)

                &&

                ((l.defaultdisplay !== 'A' || getCurrent) || self._vue.$mainConfig.hideCurrentDistrictsFromDropdown === false)
        })
            .map((l) => {
                return {
                    name: l.displayname,
                    id: l.tablename
                }
            });
    }

    getLayerDisplayNameFromId(id) {
        const _layer = this._vue.$pgConfig.filter((f) => f.tablename === id);
        if (_layer.length === 0) return "";
        return _layer[0].displayname;
    }

    getSourceLayerFromLayerId(id) {
        const _layer = this._vue.$pgConfig.filter((f) => f.tablename === id);
        if (_layer.length === 0) return "";
        return _layer[0]["source-layer"];
    }

    getProposalIdfromTableName(id) {
        const _layer = this._vue.$pgConfig.filter((f) => f.tablename === id);
        if (_layer.length === 0) return "";
        return _layer[0].proposal_id;
    }

    getTableNameFromIdandDistrictType(id, type) {
        const _layer = this._vue.$pgConfig.filter((l) => l.proposal_id === id && l
            .tags
            .replace(' ', '')
            .split(',')
            .includes(type));

        if (_layer.length === 0) return "";
        return _layer[0].tablename;
    }

    getDefaultLayerForSide(side, type = 'cd') {
        return this._vue.$pgConfig.filter((l) => l.defaultdisplay === side && l
            .tags
            .replace(' ', '')
            .split(',')
            .includes(type))[0];
    }

    initToggledLayersFromUrl(map) {
        let layersSetOnInUrl = this._vue.$querystringManager.route.query["toggledlayers"];
        if (!layersSetOnInUrl || typeof layersSetOnInUrl === 'undefined') return;
        const layerArr = layersSetOnInUrl.split(',');

        if (layerArr.length < 1) return;
        layerArr.forEach(layerTag => {
            const layer = this._vue.$mainConfig["toggleable-layers"].filter(l => l.tag === layerTag)[0];

            if (layer["layer-ids"]) {
                layer["layer-ids"].forEach(id => {
                    if (this.layerExists(id)) {
                        map.setLayoutProperty(id, "visibility", "visible");
                    } else {
                        console.warn(`Toggled layer '${id}' does not exist in map style.`);
                    }
                });
            }

            if (layer["mb-style"]) {
                map.setStyle(layer["mb-style"]);
            }

            if (layer["on-load-event"]) {
                EventBus.$emit(layer["on-load-event"]);
            }
        });
    }
}